<template>
  <div>
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :egressProfileId="egress_profile_id"
      :showEgressProfile="true"
      :showMatrix1="true"
      :showMatrix3="true"
      :showMatrix4="true"
      :showStudyPlan="true"
      :showCurricularMesh="true"
    ></NavigationBreadcrumb>
    <Matrix2
      :egress_profile_id="egress_profile_id"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
      :isBusy="isBusy"
      :courses_wrapper_id="courses_wrapper_id"
    ></Matrix2>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as names from "@/store/names";
export default {
  name: "Matrix2View",
  components: {
    Matrix2: () => import("./Matrix2"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      egress_profile_id: Number(this.$route.params.egress_profile_id),
      courses_wrapper_id: this.$route.params.courses_wrapper_id
        ? Number(this.$route.params.courses_wrapper_id)
        : null,
      isBusy: true,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      careers: names.CAREERS,
      egressProfiles: names.EGRESS_PROFILES,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames("mesh.career", true, "Programas"),
          to: "/careers",
        },
        {
          text: this.$getVisibleNames("manual.matriz_2", false, "Matriz 2"),
          dropdownOptions: [
            "showEgressProfile",
            "showMatrix1",
            "showMatrix3",
            "showMatrix4",
            "showStudyPlan",
            "showCurricularMesh",
          ],
        },
      ];
    },
    egressProfile() {
      if (!this.egress_profile_id) return null;
      return this.egressProfiles.find((x) => x.id == this.egress_profile_id);
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    can_update() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.egress_profile_id &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "change",
            this.career.faculty
          ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "change",
              this.egress_profile_id
            ))
        );
      }
      return false;
    },
    can_delete() {
      if (
        (this.user &&
          [
            "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
            "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group))) ||
        this.user.is_superuser
      )
        return true;
      if (
        this.career &&
        this.egress_profile_id &&
        this.user &&
        !["ADMINISTRATIVOS INSTRUCCIONALES"].some((group) =>
          this.user.group_names.includes(group)
        )
      ) {
        return (
          [
            "DIRECTIVOS FACULTAD O ESCUELA",
            "DIRECTORES DE CARRERA",
            "DIRECTORES DE CARRERA (CAMPUS)",
          ].some((group) => this.user.group_names.includes(group)) &&
          (this.$hasObjectPermission(
            "mesh.faculty",
            "delete",
            this.career.faculty
          ) ||
            this.$hasObjectPermission(
              "mesh.egressprofile",
              "delete",
              this.egress_profile_id
            ))
        );
      }
      return false;
    },
    allows_crud() {
      if (
        this.egressProfile &&
        !this.egressProfile.is_closed &&
        (this.can_update || this.can_delete)
      ) {
        const has_permission = this.$hasPermissions(
          "mesh.change_egressprofile"
        );
        if (has_permission) {
          this.$store.commit(names.MUTATE_VISIBILITY_CRUD, true);
          return has_permission;
        } else {
          return false;
        }
      } else {
        this.$store.commit(names.MUTATE_VISIBILITY_CRUD, false);
        return false;
      }
    },
  },
  methods: {
    // changeCycle(cycle_id){
    //   this.cycle_id=cycle_id
    //   this.$router.push({
    //     name: "Matrix2View",
    //     params: { egress_profile_id: this.egress_profile_id, cycle_id: cycle_id },
    //   });
    // },
  },
  watch: {
    "$route.params.courses_wrapper_id"() {
      if (
        this.$route.params.courses_wrapper_id &&
        this.$route.params.courses_wrapper_id != null
      )
        this.courses_wrapper_id = Number(this.$route.params.courses_wrapper_id);
      else this.courses_wrapper_id = null;
    },
  },
  created() {
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILES_MATTERS, {
        egress_profile_id: this.egress_profile_id,
      })
      .then(() => {
        this.isBusy = false;
      });
    this.$store.dispatch(names.FETCH_MATTERS, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_COURSES_WRAPPER, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_TIME_ALLOCATIONS);
    this.$store.dispatch(names.FETCH_FORMATION_LINES);
    this.$store.dispatch(names.FETCH_MATTER_CONTRIBUTIONS);
    this.$store.dispatch(names.FETCH_MATTER_TYPES);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS);
    this.$store.dispatch(names.FETCH_CYCLES);
    this.$store.dispatch(names.FETCH_COMPETENCE_TYPES);
    this.$store.dispatch(names.FETCH_METHODOLOGICAL_STRATEGIES);
    this.$store.dispatch(names.FETCH_PROCEDURE_EVIDENCES);
    this.$store.dispatch(names.FETCH_SUPPORT_RESOURCE_TYPES);
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS_TIME_ALLOCATION);
    this.$store.dispatch(names.FETCH_RA_MICROS);
    if (
      this.egress_profile_id != null &&
      this.institution &&
      (this.institution.uses_ipss_assessment == true ||
        this.institution.show_competence_unit)
    ) {
      this.$store.dispatch(names.FETCH_COMPETENCE_UNITS, {
        matter__egress_profile_matters__egress_profile__id:
          this.egress_profile_id,
      });
    }
    this.$store.dispatch(names.FETCH_STUDY_UNITS_BY_CICLE_AND_PROFILE, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id)
      .then((response) => {
        this.$nextTick(() => {
          if (!response.is_closed && this.can_update)
            this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, true);
          this.$store.commit(names.MUTATE_RULES_FILTER_SELECTOR, {
            visible_intelligence_options: [2, 4, 5, 7],
            disabled_selected_egress_profile: true,
          });
          this.$store.commit(names.MUTATE_FILTER_INTELLIGENCE, {
            egress_profile_id: this.egress_profile_id,
            egress_profile_matter_id: null,
            competence_unit_id: null,
            intelligence_option: 2,
          });
        });
        this.$store.commit(
          names.MUTATE_TITLE_OF_THE_PRINT,
          `${this.$getVisibleNames("manual.matriz_2", false, "Matriz 2")} - ${
            response.name
          }`
        );
        this.$store
          .dispatch(names.FETCH_CAREER, response.career)
          .then((career) => {
            this.$store.dispatch(names.FETCH_CAPACITIES, {
              faculty_id: career.faculty,
            });
          });
      });
    this.$store.dispatch(names.FETCH_PROFILE_CYCLES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_PROFILE_COMPETENCES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_RA_BASES, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_EGR_PROFILE_RA_BASES, {
      egress_profile_id: this.egress_profile_id,
    });
    // .then((response) => {
    //   response.forEach((element) => {
    //     // this.$store.dispatch(names.FETCH_RA_BASES, element.competence);
    //     this.$store.dispatch(names.FETCH_COMPETENCE, element.competence);
    //   });
    // });
    this.$store.dispatch(names.FETCH_COMPETENCES, this.egress_profile_id);
    this.$store.dispatch(names.FETCH_RA_MACROS, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store.dispatch(names.FETCH_TAXONOMIES);
    // this.$store.dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id);
  },
  mounted() {
    if (
      this.user &&
      this.user.student_card &&
      this.user.group_names.includes("ESTUDIANTES") &&
      this.user.student_card.egress_profile != this.egress_profile_id
    ) {
      this.$router.push({
        name: "Page403",
      });
    }
    if (this.user && this.user.group_names.includes("PROFESORES")) {
      this.$restful
        .Get(`/mesh/fully_visible_professor_egress_profiles/`)
        .then((response) => {
          if (!response.includes(this.egress_profile_id)) {
            this.$router.push({
              name: "Page403",
            });
          }
        });
    }
    if (this.user)
      this.$store.dispatch(names.FETCH_CURRENT_POSITION, this.user.id);
    this.$store.commit(names.MUTATE_PRINT_ORIENTATION, false);
    this.$store.commit(names.MUTATE_PRINT_ZOOM_SCALE, 1);
  },
  beforeDestroy() {
    this.$store.commit(names.RESET_PRINT_ZOOM_SCALE);
    this.$store.commit(names.RESET_PRINT_ORIENTATION);
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
    this.$store.commit(names.MUTATE_DELETE_FILTER_INTELLIGENCE);
    this.$store.commit(names.MUTATE_SHOW_INTELLIGENCE_SIDEBAR, false);
    this.$store.commit(names.MUTATE_DELETE_RULES_FILTER_SELECTOR);
  },
};
</script>

<style>
</style>
